import { Box, Container, Grid, Typography } from '@mui/material';
import hero from '../../assets/energy-backdrop.jpg';
import arrow from '../../assets/ArrowLarge_White.svg';
import { useNavigate } from 'react-router-dom';

export const Page5 = () => {
    const navigate = useNavigate();
    return (
        <Container maxWidth={false} sx={{ paddingTop: '20px' }}>
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: {
                        sx: 1,
                        sm: 2,
                        lg: 5
                    },
                    marginTop: '10px',
                }}
            >
                <Grid
                    container
                    sx={{
                        borderRadius: '36px',
                        overflow: 'hidden',
                        backgroundImage: `url(${hero})`,
                        backgroundSize: 'cover',
                        backgroundPosition: {
                            xs: '65% center',
                            sm: '65% center', // Adjusts background image to be 75% towards the right on extra-small screens
                            md: 'center center', // Centers background image on small screens and up
                        },
                        backgroundRepeat: 'no-repeat',
                        minHeight: '80vh',
                        padding: {
                            md: '50px',
                            xs: '20px'
                        },
                        paddingTop: {
                            md: '100px',
                            xs: '20px'
                        },
                        height: '100%', // Ensure the grid takes full height
                    }}
                >
                    <Grid
                        item
                        md={8}
                        xs={7}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between', // Ensure space between the title and the Explore button
                            minHeight: '100%',
                            height: 'auto',
                            flex: 1,
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    // Liquid glass container wrapper
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    backdropFilter: 'blur(10px)',
                                    WebkitBackdropFilter: 'blur(10px)',
                                    borderRadius: {
                                        xs: '20px',
                                        md: '20px',
                                    },
                                    padding: {
                                        xs: '32px 24px',
                                        md: '40px 32px',
                                    },
                                    border: '1px solid rgba(255, 255, 255, 0.3)',
                                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                                    width: {
                                        xs: 'auto',
                                        md: 'auto',
                                    },
                                    maxWidth: {
                                        xs: '100%',
                                        md: '100%',
                                    },
                                    display: 'inline-block',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: 'ClaireMurphy',
                                        fontSize: {
                                            xs: '32px', // Increased font size on extra-small screens
                                            sm: '60px', // Increased font size on small screens
                                            md: '72px', // Increased font size on medium screens and larger
                                        },
                                        fontWeight: 400,
                                        lineHeight: '1.3',
                                        textAlign: 'left',
                                        color: '#fff',
                                        letterSpacing: '0.05em',
                                    }}
                                >
                                    {`ITS ABOUT`}<br /> {`BEING REAL`}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    maxWidth: '400px',
                                    padding: '20px 24px',
                                    marginLeft: '50px',
                                    marginTop: '30px',
                                    display: {
                                        xs: 'none',
                                        md: 'block'
                                    },
                                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                    backdropFilter: 'blur(10px)',
                                    WebkitBackdropFilter: 'blur(10px)',
                                    borderRadius: '20px',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand',
                                        fontSize: 'clamp(12px, 5vw, 18px)',
                                        fontWeight: 600,
                                        lineHeight: '26.1px',
                                        textAlign: 'left',
                                        color: '#fff',
                                    }}
                                >
                                    Discover Bielenda Supremelab under Lavisha Skincare - professional home care cosmetics created by Bielenda Professional. Our products are inspired by successful professional cosmetic treatments, featuring effective active ingredients in optimal concentrations for visible results.
                                </Typography>
                            </Box>
                        </Box>

                        <Box
                            onClick={() => {
                                navigate('/story');
                            }}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                mt: 'auto', // Push the box to the bottom
                                paddingLeft: {
                                    xs: '0px',
                                    md: '50px'
                                },
                                cursor: 'pointer'
                            }}>

                            <Typography
                                sx={{
                                    fontFamily: 'Quicksand',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    lineHeight: '20px',
                                    letterSpacing: '0.1em',
                                    textAlign: 'left',
                                    color: '#FFF',
                                    mr: 2
                                }}
                            >
                                DISCOVER OUR INGREDIENTS
                            </Typography>
                            <Box
                                component="img"
                                src={arrow}
                                alt="Explore"
                                sx={{
                                    width: '55px',
                                    height: '55px',
                                    color: '#fff'
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
